import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import React from 'react'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'
import { ReactComponent as ImageBoxes } from '../../assets/imagens/modal-setup-boxes.svg'

const ModalWrapper = styled.div`
  background-color: rgba(19, 26, 45, 0.5);
  display: ${( { open } ) => open ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
`

const Modal = styled.div`
  background-color: ${StyleGuide.cores.branco};
  border-radius: 16px;
  width: 500px;
  height: auto;
  padding: 24px 32px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 101;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    width: 312px;
    max-width: 90%;
    padding: 16px 20px;
    gap: 16px;
  }
`

const MainContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    gap: 12px;
  }
`

const ImageContainer = styled.div`
  flex-shrink: 0;
  width: 30px;

  svg {
    width: 30px;
    height: 127px;
  }

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    width: 24px;

    svg {
      width: 24px;
      height: 96px;
    }
  }
`

const TextItemsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 127px;
  position: relative;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    height: 96px;
  }
`

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;

  &:first-child {
    top: 22px;
  }

  &:last-child {
    top: 84px;
  }

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    &:first-child {
      top: 16px;
    }

    &:last-child {
      top: 62px;
    }
  }
`

const Text = styled.p`
  color: #222F64;
  font-family: 'Lato';
  font-size: 16px;
  line-height: 22px;
  margin: 0;
  font-weight: 400;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
  }
`

const TitleContainer = styled.div`
  text-align: center;
`

const Title = styled.h3`
  color: #222F64;
  font-size: 16px;
  font-family: 'Lato';
  line-height: 20px;
  font-weight: 700;
  margin: 0;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    font-size: 12px;
    line-height: 18px;
    font-weight: 700;
  }
`

const StyledButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  background-color: #222F64;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border: none;
  cursor: pointer;

   @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    height: 40px;
    font-size: 12px;
    padding: 10px 20px;
  }
`

const ModalSetup = ( { open, onClick, firstKit, secondKit } ) => {
  return (
    <ModalWrapper open={ open }>
      <Modal>
        <MainContent>
          <ImageContainer>
            <ImageBoxes />
          </ImageContainer>

          <TextItemsContainer>
            <TextWrapper>
              <Text>
                Sua primeira experiência é { firstKit }
              </Text>
            </TextWrapper>
            <TextWrapper>
              <Text>
                E sua segunda caixinha será o kit { secondKit }
              </Text>
            </TextWrapper>
          </TextItemsContainer>
        </MainContent>

        <TitleContainer>
          <Title>Agora é só aguardar a entrega na sua casa</Title>
        </TitleContainer>
        <StyledButton
          onClick={ onClick }
        >
          ENTENDI
        </StyledButton>
      </Modal>
    </ModalWrapper>
  )
}

ModalSetup.propTypes = {
  'firstKit': string.isRequired,
  'onClick': func.isRequired,
  'open': bool.isRequired,
  'secondKit': string.isRequired
}

export default ModalSetup
